export const merchShopAssets = {
	banner: {
		desktop: "/spec_merch_shop/banner-merch-shop-desktop.png",
		mobile: "/spec_merch_shop/banner-merch-shop-mobile.png"
	},
	items: {
		explore: {
			desktop: "/spec_merch_shop/explore.jpg",
			mobile: "/spec_merch_shop/explore-mobile.jpg"
		},
		apparel: {
			desktop: "/spec_merch_shop/apparel.jpg",
			mobile: "/spec_merch_shop/apparel-mobile.jpg"
		},
		accessories: {
			desktop: "/spec_merch_shop/accessories.jpg",
			mobile: "/spec_merch_shop/accessories-mobile.jpg"
		}
	}
} as const;
